export default {
  props: {
    element: [Object, Array],
  },
  render: function (createElement) {
    return createElement('div', this.element)
  },
}
